<template>
  <Layout>
    <div class="section content has-text-white">
      <h1 class="is-size-5 has-text-primary">{{ $t('Imprint') }}</h1>
      <span class="is-size-7">
        <p>
          Име на фирмата: Business Fleet s.r.o.<br>
          Адрес на компанията: Lidická 700/19 | Veveří, 602 00 Brno | Czech Republic, USt-IdNr: CZ24814776<br>
          Електронна поща: <a class="has-text-primary" href="mailto:778mobile.bg@silverlines.info">keepyoufit.bg@silverlines.info</a><br>
          Линия за помощ: <a class="has-text-primary" href="tel:024928370">024928370</a> / <a class="has-text-primary" href="tel:024487202">024487202</a>
        </p>
      </span>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/Kyf'

export default {
  name: 'Imprint',
  components: {
    Layout
  }
}
</script>




// WEBPACK FOOTER //
// src/components/LangKyf/BG/Imprint.vue